import { useState } from 'react'
import Modal from 'react-modal'
import ImageInput from '../ImageInput/ImageInput'
import TextInput from '../TextInput/TextInput'
import { ReactComponent as ImageIcon } from 'assets/icons/image.svg'
import Dropdown from '../Dropdown/Dropdown'

const TipTapImage = ({ value, onChange, theme }) => {
  const iconColor = theme === 'light' ? '#333' : '#eee'
  const [isOpen, setIsOpen] = useState(false)
  const [currentValue, setCurrentValue] = useState()
  const shapeOptions = [
    {
      id: '0px',
      name: 'Rectangle',
    },
    {
      id: '4px',
      name: 'Rounded Rectangle',
    },
    {
      id: '500em',
      name: 'Circle',
    },
  ]
  function handleSetImage(image) {
    setCurrentValue(image)
  }
  function handleOpen() {
    setCurrentValue({ ...value, name: value.caption })
    setIsOpen(true)
  }

  function handleCancel() {
    setIsOpen(false)
  }

  function handleSubmit() {
    onChange({ ...currentValue, caption: currentValue.name })
    setIsOpen(false)
  }

  return (
    <div className="tiptap-image">
      <button
        onClick={handleOpen}
        className="image-button"
        data-tooltip="Image"
      >
        <ImageIcon fill={iconColor} width="26" height="26" />
      </button>
      <Modal
        isOpen={isOpen}
        onRequestClose={handleCancel}
        contentLabel="Embeded Link Modal"
        className="modal w-[600px]"
        overlayClassName="modal-overlay"
      >
        <div className="">
          <h2 className=" p-6 bg-gray-light rounded-t">Add / Edit Image</h2>
          <div className="p-6">
            <ImageInput value={currentValue} onChange={handleSetImage} />
            <div className="mt-4">
              <TextInput
                label="Alt"
                value={currentValue?.alt || ''}
                onChange={(evt) =>
                  setCurrentValue({ ...currentValue, alt: evt.target.value })
                }
              />
            </div>
            <div className="mt-4">
              <Dropdown
                label="Shape"
                value={currentValue?.borderRadius || '0px'}
                options={shapeOptions}
                onChange={(value) =>
                  setCurrentValue({ ...currentValue, borderRadius: value })
                }
              />
            </div>
          </div>

          <div className="flex justify-end mt-6 p-6 bg-gray-dark">
            <button className="button " onClick={() => setIsOpen(false)}>
              Cancel
            </button>
            <button
              className="button bg-pink hover:bg-pink-off"
              onClick={handleSubmit}
            >
              Save
            </button>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default TipTapImage
